module.exports = __webpack_public_path__ + "img/img20.3e57e20a.png";